module.exports = __webpack_public_path__ + "static/img/logo2.027ca5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2.jpg
// module id = EiiO
// module chunks = 2